<template>
  <div class="withdrawal">
    <div class="line-box">
      <div class="line-identity">
        <div class="panel">
          <template>
            <span class="title">提现金额</span>
            <div class="number">
              <span class="input">￥
                <van-field  
                  v-model="amount" 
                  :maxlength="8" 
                  class="inputVal" 
                  autofocus 
                  type="number" 
                  @blur="checkFeeValid"
                />
              </span>
            </div>
            <div class="tips" v-html="text"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="button bgd" @click="$router.go(-1)">返回</div>
      <div class="button" @click="confirmWithdrawal">确认提现</div>
    </div>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
const md5 = require('md5');
export default {
  data() {
    return {
      amount: 0,
      balanceInfo: {},
      userInfo: {},
      text: ""
    };
  },
  mounted() {
    this.balanceInfo = JSON.parse(JSON.stringify(this.$route.query))
    this.amount = JSON.parse(JSON.stringify(this.balanceInfo.balance || 0))
    this.queryPublicityData()
  },
  methods: {
    queryPublicityData() {
      this.$api.h5.queryPublicityData('UNION_PAY_CONFIG')
        .then(res => {
          this.text = res.data.TIPS_TEXT
        })
    },
    confirmWithdrawal() {
      if (this.amount <= 0) {
        this.$toast(`请输入提现金额`)
      } else if (Number(this.amount || 0) > this.balanceInfo.balance ) {
        this.$toast(`本次最多可提现：${this.balanceInfo.balance}元`)
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: `正在进行提现操作！<br />请确认本次提现金额：${this.amount}元`,
        }).then(() => {
            this.applyWithdrawal()
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 提现请求
    applyWithdrawal() {
      const parmes = {amount: this.amount,sign: '' }
      parmes.sign = md5(`amount${this.amount}s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
      this.$api.withdrawal.unionApplyWithdrawal(parmes)
        .then(res => {
          if (res.data) {
            this.$toast('提现申请成功！')
            this.$router.go(-1)
          }
        }).catch(err => {})
    },
    checkFeeValid() {
      this.amount = round2Places(this.amount)
    },
  }
};
</script>

<style lang="stylus" scoped>
.withdrawal {
  height: 100vh;
  background: #F4F4F4;
  overflow hidden
  .line-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 47px;
    background: #FEF3E6;
    border-radius: 8px;
    .line-identity {
      width: 353px;
      height: 27px;
      background: #FF712D;
      box-shadow: inset 0px 1px 6px 0px #CC641E;
      border-radius: 8px;
      .panel {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 325px;
        // height: 392px;
        padding: 40px 0;
        margin: auto;
        margin-top: 14px;
        background: linear-gradient(180deg, #FEF3E6 0%, #FFFEFF 100%);
        .title {
          color: #333333;
          font-size: 15px;
          font-weight: 400;
        }
        .number {
          color: #FF6B31;
          font-size: 44px;
          font-weight: bold;
          margin-top: 20px;
          display: flex
          text-align: center
          .input {
            display: flex;
            align-items: center
            justify-content: center;
            font-size: 23px;
            .inputVal  {
              font-size: 24px;
              width 45%
              border: none
              background: none
              -webkit-text-fill-color:  #FF6B31;
            }
          }
    
        }
        .tips {
          padding: 0 10px;
          color: #999999;
          font-size: 11px;
          margin-top: 18px;
          line-height 20px;
        }
        p {
          color: #999999;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 84px;
    background: #FFFFFF;
    box-shadow: 0px -3px 9px 0px rgba(220, 220, 220, 0.3);
    .button {
      width: 138px;
      height: 43px;
      font-size: 17px;
      color: #FF6B31;
      text-align: center;
      line-height: 43px;
      border-radius: 8px;
      border: 1px solid #FF6B31;
      margin-top: 10px;
    }
    .bgd {
      color: #FFFFFF;
      background: #FF6B31;
    }
  }
}
 
</style>
